




































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class Alergi extends Vue {
  @Prop() setAlergi: string;
  // alergi = "";
  label = "";
  placeholder = "Alergi";
  // validasi = [(v) => !!v || "*Kolom ini harus diisi"];
  // get alergi() {
  //   return this.setAlergi;
  // }
  // set alergi(value) {
  //   this.$emit("alergi", value);
  // }
  // @Watch("alergi")
  // changeAlergi(v) {
  //   if (!v) {
  //     this.label = "";
  //     this.placeholder = "Alergi";
  //   } else {
  //     this.placeholder = "Alergi";
  //     this.label = "Alergi";
  //   }
  //   this.$emit("alergi", v);
  // }
  showAlergi = false;
  radioAlergi = "0";
  mounted() {
    if (!this.setAlergi) {
      // console.log("kosong");
      this.label = "";
      this.placeholder = "Alergi";
      this.radioAlergi = "0";
    } else {
      // console.log("ada");
      this.placeholder = "Alergi";
      this.label = "Alergi";
      this.radioAlergi = "1";
    }
  }
  @Watch("radioAlergi")
  change(v) {
    if (this.radioAlergi == "0") {
      this.showAlergi = false;
      this.setAlergi = null;
    } else {
      this.showAlergi = true;
    }
  }
  @Watch("setAlergi")
  changeSetAlergi(v) {
    if (!v) {
      this.label = "";
      this.placeholder = "Alergi";
      this.radioAlergi = "0";
    } else {
      this.placeholder = "Alergi";
      this.label = "Alergi";
      this.radioAlergi = "1";
    }
    this.$emit("alergi", v);
    // this.alergi = v;
  }
}
